var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1723794875908,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 16658,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M819.3 849.7h-580c-19.3 0-35-15.7-35-35v-580c0-19.3 15.7-35 35-35h580c19.3 0 35 15.7 35 35v580c0 19.3-15.6 35-35 35z",
    fill: "#D1C4E9",
    "p-id": 16659
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M819.3 857.2h-580c-23.4 0-42.5-19.1-42.5-42.5v-580c0-23.4 19.1-42.5 42.5-42.5h580c23.4 0 42.5 19.1 42.5 42.5v580c0 23.4-19 42.5-42.5 42.5z m-580-650c-15.2 0-27.5 12.3-27.5 27.5v580c0 15.2 12.3 27.5 27.5 27.5h580c15.2 0 27.5-12.3 27.5-27.5v-580c0-15.2-12.3-27.5-27.5-27.5h-580z",
    fill: "#9C27B0",
    "p-id": 16660
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.6 536.6h-47.5c-13.1 0-23.7 10.6-23.7 23.7v95c0 13.1 10.6 23.7 23.7 23.7h47.5c13.1 0 23.7-10.6 23.7-23.7v-95c0-13.1-10.6-23.7-23.7-23.7z m142.5-166.3h-47.5c-13.1 0-23.7 10.6-23.7 23.7v261.3c0 13.1 10.6 23.7 23.7 23.7h47.5c13.1 0 23.8-10.6 23.8-23.7V394.1c-0.1-13.1-10.7-23.8-23.8-23.8z m142.5 71.3h-47.5c-13.1 0-23.8 10.6-23.8 23.8v190c0 13.1 10.7 23.7 23.8 23.7h47.5c13.1 0 23.7-10.6 23.7-23.7v-190c0-13.2-10.6-23.8-23.7-23.8z m0 0",
    fill: "#9C27B0",
    "p-id": 16661
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.472e7cf306e9e324476a06aed9dda85a.svg";
export { ForwardRef as ReactComponent };